class MessageController {
    constructor() {
        this.isBlocked = false;
        this.timeouts = new Set();
        this.intervals = new Set();
    }

    blockMessages() {
        this.isBlocked = true;
        this.clearAllPending();
    }

    unblockMessages() {
        this.isBlocked = false;
    }

    clearAllPending() {
        this.timeouts.forEach(timeoutId => clearTimeout(timeoutId));
        this.timeouts.clear();
        this.intervals.forEach(intervalId => clearInterval(intervalId));
        this.intervals.clear();
    }

    safeSetMessages(setMessages, updateFn) {
        if (this.isBlocked) return;
        setMessages(updateFn);
    }

    safeTimeout(callback, delay) {
        if (this.isBlocked) return;
        const timeoutId = setTimeout(() => {
            this.timeouts.delete(timeoutId);
            callback();
        }, delay);
        this.timeouts.add(timeoutId);
        return timeoutId;
    }
}

export const messageController = new MessageController();

export const safeSetMessages = (setMessages, updateFn) => {
    messageController.safeSetMessages(setMessages, updateFn);
};
